// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__65Wub","bgStyles":"Content_bgStyles__000wm"};